/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum InputDisplayModeEnum {
    EDIT = 'EDIT',
    VIEW = 'VIEW'
}
